import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import PermanentIndustrialIdentification from "./sections/PermanentIndustrialIdentification";
import TheEvermarkStandard from "./sections/TheEvermarkStandard";
import SixCoreMarkingServices from "./sections/SixCoreMarkingServices";
import ThreeKindsOfBuyers from "./sections/ThreeKindsOfBuyers";
import ComplianceAndStandards from "./sections/ComplianceAndStandards";
import SubmitYourSpecifications from "./sections/SubmitYourSpecifications";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <PermanentIndustrialIdentification />
      <TheEvermarkStandard />
      <SixCoreMarkingServices />
      <ThreeKindsOfBuyers />
      <ComplianceAndStandards />
      <SubmitYourSpecifications />
      <SiteFooter />
    </div>;
}